import { Component } from 'src/utils';
import logoIcon from './../../../images/small-logo.png';
import houseIcon from './../../../images/house-icon.png';
import template from './faq-franchising.html';

@Component({
  controllerAs: 'franchising',
  template
})

export default class Franchising {
  static $inject = [
    '$state',
    '$location',
    'APP',
    '$stateParams',
    '$window',
    'authService'
  ];

  constructor($state, $location, $auth, $window, $stateParams, APP) {
    this.$state = $state;
    this.$location = $location;
    this.logoIcon = logoIcon;
    this.houseIcon = houseIcon;
    this.$stateParams = $stateParams;
    this.$window = $window;
    this.$auth = $auth;
   
    this.APP = APP;
  }

  goToHomePage() {
    let storeName = '';
    if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
      storeName = this.$stateParams.storeName;
    } else {
      if (this.profile.store && this.profile.store.storeName) {
        storeName = this.profile.store.storeURLName;
      } else {
        storeName = this.$auth.getGuestStoreDetail().storeName;
      }
    }
    if (storeName) {
      this.$window.location.href = '/' + storeName;
    } else {
      this.$state.go('home');

    }
  }

  isLoggedIn() {
    return this.$location.path().indexOf('auth') === -1 &&
      this.$state.current.name !== 'login' &&
      this.$state.current.name !== 'signup';
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/static/faq-franchising.js